import { useEffect, useRef, useState } from 'react'
import DetailedTooltip from '../../GenericComponents/Tooltip/DetailedTooltip'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import ReportActions from './ReportActions'
import { getToolTipContent } from './ReportTooltip'
import { FoundationsInput } from '../../GenericComponents/input'
import { exec } from 'child_process'
import { useEditSaveVUMutation } from '../../Redux/ReportActions/reportActionsSlice'
import { getMeasureListForVUID } from '../../VisualunitHelpers'
import {
    getVuObjInfoState,
    getVUParamsInfoState,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { useSelector } from 'react-redux'
import { FoundationsConstants } from '../../FoundationsConstants'
import { onEnter } from '../../GlobalMethods'
import { FoundationsEnums } from '../../enum'
import HandleAnyPopupMessage from '../handleAnyPopupMessage'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { getCurrentUserData, RootState } from '../../Redux/store'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'

import { useZustandVisualUnitStore } from './vuContext'

const ReportInfo = (props: {
    report: VisualUnitApiDTO_VisualUnit
    tempVuData: VisualUnitApiDTO_VisualUnit_Extended
    isAdmin: boolean
    sqlString: string
    isCollapsed: boolean
    LastRefreshedTime: string
    dashboardId: number
    operationStatusMessage: string
    snapShotCount: number
    isLoading: boolean
    isDrillThruLaunched: boolean
    isExplore: boolean
    toggleIsExplore: () => void
    doExpColVisualUnit: (isCollapsed: boolean) => void
    markFavourite: () => void
    setiseditSettingsDialogOpen: (iseditSettingsDialogOpen: boolean) => void
    refreshVisualUnit: () => void
    setReport: (val: VisualUnitApiDTO_VisualUnit_Extended) => void
    onVisibilityChange: (isVisible: boolean) => void
    actionType?: string
    tableJSOnData?: { [s: string]: any }
    intervalCount: number
    executeResult?: any
    setremoveFromWorkspace : ({ flag, id }: { flag: boolean; id: number }) => void;                                                                         
    
}) => {
    const {
        report,
        tempVuData,
        isAdmin,
        sqlString,
        isCollapsed,
        LastRefreshedTime,
        dashboardId,
        operationStatusMessage,
        snapShotCount,
        isLoading,
        isDrillThruLaunched,
        isExplore,
        toggleIsExplore,
        doExpColVisualUnit,
        markFavourite,
        setiseditSettingsDialogOpen,
        refreshVisualUnit,
        setReport,
        onVisibilityChange,
        tableJSOnData,
        intervalCount,
        executeResult,
        setremoveFromWorkspace,
    } = props
    const [callEditSaveVUAPI] = useEditSaveVUMutation()
    const [name, setName] = useState(report.Name)
    const [editingName, setEditingName] = useState(false)
    const vuObjParamsFromStore = useSelector(getVUParamsInfoState)
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState)
    const [vuObj, setVuObj] = useState(vuObjDataInfoFromStore)
    const currentUserData = useSelector((state: RootState) => getCurrentUserData(state))
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [exportPopupMessage, setExportPopupMessage] = useState<React.ReactNode>('');

    const updateVUName = useZustandVisualUnitStore((s) => s.updateVUName);

    const triggerExportPopup = (message: React.ReactNode) => {
        setExportPopupMessage(message);
        setShowExportPopup(true);
    };

    const handleCloseExportPopup = () => {
        setShowExportPopup(false); // Only reset the popup state, no effect on dropdown
        setExportPopupMessage(''); // Clear message on close
    };

    const handleUpdateVUName = () => {
        if (name !== tempVuData.Name) {
            const measureFilterList = getMeasureListForVUID(
                tempVuData.VisualUnitId,
                vuObjDataInfoFromStore,
                vuObjParamsFromStore,
                vuObj,
                tempVuData.MeasureList,
                setVuObj,
                tempVuData
            )
            const currentlist = measureFilterList.filter(
                (item: any) => item.id === tempVuData.VisualUnitId
            )
            const reqVisualUnitData = {
                id: tempVuData.VisualUnitId,
                tempVuId: tempVuData.TempVisualUnitId,
                name: name,
                description: tempVuData.Description,
                viewerType: tempVuData.ViewerType,
                preview: tempVuData.Preview,
                refreshInterval: tempVuData.RefreshInterval,
                vuDeId: -1,
                privacyLock: tempVuData.PrivacyLock,
                allowDrillThru: tempVuData.AllowDrillThru,
                measures: currentlist[0]?.measures,
                filterable: currentlist[0]?.filterable,
                dimensionRow: currentlist[0]?.dimensionRow,
                dimensionCol: currentlist[0]?.dimensionCol,
                saveChartSwitch: tempVuData.ChartSwitch,
                saveChartSettings: tempVuData.ChartSettings,
                dashboardName: 'Temp',
                IsEnabledAutoNavigation: tempVuData.IsEnabledAutoNavigation,
                vuDetails: tempVuData,
                tooltipContent: '',
                DrillthruPageSize: tempVuData.DrillthruPageSize,
                saveTableSettings: tempVuData.TableSettings || {},
                refinementProfile: tempVuData.refinementProfile,
                callerType: FoundationsConstants.enumVUCallerType.Explore,
                DashBoardId: dashboardId,
            }

            //Send form data to API
            updateVUName(name)
            callEditSaveVUAPI(reqVisualUnitData)
                .unwrap()
                .then((EditSaveVUResponse) => {
                    if (EditSaveVUResponse && EditSaveVUResponse.vuDetails) {
                        setReport({
                            ...report,
                            ...EditSaveVUResponse.vuDetails.data,
                        })
                    }
                    FoundationsGenericToaster("success", "Report Updated Successfully")
                })
                .catch((error) => {
                    console.error('Error in callEditSaveVUAPI:', error)
                })
        }
    }

    const updateName = (event: any) => {
        if (editingName) {
            if (!(event.target instanceof HTMLInputElement)) {
                handleUpdateVUName();
                setEditingName(false);
            } else {
                onEnter(event, () => {
                    handleUpdateVUName();
                    setEditingName(false);
                });
            }
        }
    };
    const [isFlashing, setIsFlashing] = useState(false);

    const handleCopy = () => {
        setIsFlashing(true);
        setTimeout(() => setIsFlashing(false), 1000);
    };

    return (
        <div
            id={'dashboard_vu_info_wrapper_' + tempVuData.VisualUnitId}
            className="dashboard-vu-info-wrapper"
            onClick={(e) => updateName(e)}
        >
            <div
                id={'dashboard_vu_info_' + tempVuData.VisualUnitId}
                className="dashboard-vu-info float-left"
            >
                {!isExplore && (
                    <>
                        <span
                            id={'link_dashboard_vu_collapse_' + tempVuData.VisualUnitId}
                            className="image large dashboard-vu-expanded"
                            onClick={() => doExpColVisualUnit(true)}
                            title="Collapse this report"
                            style={{ display: isCollapsed ? 'none' : 'inline' }}
                        >
                            ▼
                        </span>
                        <span
                            id={'link_dashboard_vu_expand_' + tempVuData.VisualUnitId}
                            className="image large dashboard-vu-collapsed hide"
                            onClick={() => doExpColVisualUnit(false)}
                            title="Expand this report"
                            style={{ display: !isCollapsed ? 'none' : 'inline' }}
                        >
                            ►
                        </span>
                    </>
                )}
                <span
                    id={'visual_unit_name_' + tempVuData.VisualUnitId}
                    className={
                        'dashboard-vu-header visual-unit-name ' + (!editingName ? '' : 'hide')
                    }
                    onDoubleClick={() => {
                        if (!isExplore) setEditingName(true)
                    }}
                >
                    {(tempVuData.Name!= name && tempVuData.Name!="") ? tempVuData.Name :name}
                </span>

                {/* INPLACE EDIT NAME */}
                <FoundationsInput
                    id={'edit_visual_unit_name_' + tempVuData.VisualUnitId}
                    type="text"
                    onInput={(event: { target: { value: string } }) => setName(event.target.value)}
                    onKeyDown={updateName}
                    onBlur={updateName} // Switch back to view mode when input loses focus
                    value={name}
                    maxLength={100}
                    SkipDline={true}
                    inputStyle={{
                        border: '1px solid #767676',
                        width: '100%',
                        verticalAlign: 'middle',
                    }}
                    containerClasses={
                        'edit-visual-unit-name dashboard-vu-header ' + (editingName ? '' : 'hide')
                    }
                />
                {/* END INPLACE EDIT NAMe */}

                {!isExplore && (
                    <>
                    <span className="dashboard-menu-divider">•</span>
                    <span className='mr-1'>
                        {/* VISUALUNIT INFO TOOLTIP */}
                        <DetailedTooltip
                            key={'vu_tooltip_info_link_' + tempVuData.VisualUnitId}
                            content={getToolTipContent(tempVuData, isAdmin, sqlString, isFlashing)}
                            placement="bottom"
                            animation="shift-away-subtle"
                            isCopyable={isAdmin}
                            copyText={sqlString || "-none-"}
                            onCopy={handleCopy}
                            allowHTML={true}
                            showIcon={true}
                            icon={<>ⓘ</>}
                            trigger={'mouseenter focus'}
                            delay={[100, 0]}
                        ></DetailedTooltip>
                        </span>
                        {/* END VISUALUNIT INFO TOOLTIP */}

                        {/* FAVORITES BUTTON */}
                        <a
                            onClick={() => {}}
                            id={'buttonFavVUSaveChanges_' + tempVuData.VisualUnitId}
                            className="FavVUbutton mr-1"
                        >
                            <i
                                className={`feather ${tempVuData.AddedToFavourite ? 'icon-star-on shine' : 'icon-star'} cursor-pointer  indivualTable-star-icon indivualTable-star-icon m-1`}
                                id={'React_button_FavVUSaveChanges_' + tempVuData.VisualUnitId}
                                onClick={() => markFavourite()}
                            ></i>
                        </a>
                        {/* END FAVORITES BUTTON */}
                        {/* REPORT SETTINGS ICON */}
                        {
                            (tempVuData.AppGUID=== '') && (currentUserData.privileges?.includes('VisualUnit_Update')) &&
                            (
                                <span
                                    title="Change report name and description"
                                    className="link_rename_vu feather icon-settings"
                                    onClick={() => setiseditSettingsDialogOpen(true)}
                                ></span>
                            )
                        }
                        
                        {/* END REPORT SETTINGS ICON */}
                    </>
                )}
            </div>
            <div className="dashboard-vu-action float-right">
                {intervalCount !== 0 && !isCollapsed && LastRefreshedTime && !isExplore && (
                    <span
                        id={'table-last-refreshed-time_' + tempVuData.VisualUnitId}
                        className="feather icon-refresh-ccw mr-3"
                        title="This is an auto-refreshing report"
                        style={{
                            color: 'rgb(193 193 193)',
                            alignContent: 'center',
                            height: ' 100%',
                            display: 'inline-block',
                        }}
                    >
                        {' ' + LastRefreshedTime}
                    </span>
                )}
                {isLoading && (
                    <li className="dashboard-vu-action-item">
                        <span
                            id={'vu_header_loading_' + tempVuData.VisualUnitId}
                            className="padding-right-large"
                        >
                            <span className="ajax-loading-box">
                                <span className="ajax-loading-image">Loading...</span>
                            </span>
                        </span>
                    </li>
                )}
                {/* REPORT ACTIONS */}
                {/* TODO: render different actions for active panel  */}                
                {!isCollapsed && (
                    <ReportActions
                        tempVuData={tempVuData}
                        dashboardId={dashboardId}
                        OperationStatusMessage={operationStatusMessage}
                        snapshotCount={snapShotCount}
                        isDrillThruLaunched={isDrillThruLaunched}
                        toggleIsExplore={toggleIsExplore}
                        refreshVisualUnit={refreshVisualUnit}
                        onVisibilityChange={onVisibilityChange}
                        actionType={props.actionType}
                        currentTableData= {tableJSOnData}
                        triggerExportPopup={triggerExportPopup}
                        isExplore={isExplore}
                        executeResult={executeResult}
                        setremoveFromWorkspace={setremoveFromWorkspace}
                        isSummary={false}
                        setShowExportPopup={setShowExportPopup}
                    />
                )}
                <>
                <HandleAnyPopupMessage
                             isOpen={showExportPopup}
                             title="Export Data"
                             message={exportPopupMessage}
                             onClose={()=>setShowExportPopup(false)}
                             Link={null}
                             linkText=''
                         />
                </>
                {/* END REPORT ACTIONS */}
            </div>
        </div>
    )
}

export default ReportInfo
